module.exports = __webpack_public_path__ + "media/categories/7022-171e2d16.svg";